import React from 'react'

interface MiniAreaChartProps {
  className?: string
}

export const MiniAreaChart: React.FC<MiniAreaChartProps> = ({ className }) => {
  return (
    <div className={`absolute h-[124px] overflow-clip right-0 top-0 w-[185px] ${className || ''}`}>
      <div className="absolute left-0 size-[185px] top-[48px]">
        <svg
          className="w-full h-full"
          viewBox="0 0 185 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient id="areaGradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="rgba(197,204,159,0.4)" />
              <stop offset="100%" stopColor="rgba(197,204,159,0.05)" />
            </linearGradient>
          </defs>
          
          {/* Smooth wavy area fill matching Figma Frame 1686560885 */}
          <path
            d="M 0 70 C 15 45, 35 50, 50 55 C 65 60, 80 50, 95 45 C 110 40, 125 50, 140 55 C 155 60, 170 65, 185 70 L 185 137 L 0 137 Z"
            fill="url(#areaGradient)"
          />
          
          {/* Smooth wavy line */}
          <path
            d="M 0 70 C 15 45, 35 50, 50 55 C 65 60, 80 50, 95 45 C 110 40, 125 50, 140 55 C 155 60, 170 65, 185 70"
            stroke="rgba(197,204,159,0.6)"
            strokeWidth="2.5"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  )
}

export default MiniAreaChart
